












































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  EContext,
  ENumberInputType,
  EPricingTableColumn,
  PricingTableHelper,
  getRowDescriptionValue,
  getRowDiscountFlatFee,
  getRowDiscountValue,
  getRowDiscountValueIsEmpty,
  getRowFormattedDiscount,
  getRowNameValue,
  getRowNetPrice,
  getRowOptionalProductField,
  getRowPriceAfterDiscounts,
  getRowSkuValue,
  getRowTaxFlatFee,
  getRowTaxValue,
  getRowTaxValueIsEmpty,
  getRowTotalPrice,
  getRowValues,
  getRowVariableQuantityEnabled,
  getRowVariableQuantityField,
  getRowOptionalProductEnabled,
  getFilteredRowValues,
  getRowFormattedTax,
  getRowDescriptionIsEmpty,
  getRowSkuValueIsEmpty,
  getRowDiscountEnabled,
  getNumberInputType,
  hasDiscount,
} from '@getaccept/editor-lib';
import { PricingTableCheckbox } from '@getaccept/editor-lib/src/components/pricing-table';
import debounce from 'debounce';
import { SigningHelper } from '@lib-shared/signature/helpers/signing.helper';
import type {
  IMergeValues,
  IPricingTableColumn,
  IPricingTableCurrencySettings,
  IPricingTableRow,
  IField,
} from '@getaccept/editor-lib';
import type { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import type { ERecipientStatus } from '@lib-shared/recipients/types/enums/recipient-status';
import type { IRecipient } from '@lib-shared/types/Recipient';
import PricingTableUnitsModifierMenu from './PricingTableUnitsModifierMenu.vue';
import PricingTableDescriptionInput from './PricingTableDescriptionInput.vue';

@Component({
  components: {
    PricingTableDescriptionInput,
    PricingTableCheckbox,
    PricingTableUnitsModifierMenu,
  },
  data: () => ({
    ENumberInputType,
    PricingTableHelper,
    SigningHelper,
    getRowOptionalProductEnabled,
    getRowOptionalProductField,
    getRowDescriptionValue,
    getRowValues,
    EPricingTableColumn,
    getRowSkuValue,
    getFilteredRowValues,
    getRowVariableQuantityEnabled,
    getRowTaxValue,
    getRowTaxValueIsEmpty,
    getRowTaxFlatFee,
    getRowDiscountValueIsEmpty,
    getRowPriceAfterDiscounts,
    getRowTotalPrice,
    getRowFormattedDiscount,
    getRowFormattedTax,
    getRowNetPrice,
    getRowNameValue,
    getNumberInputType,
    getRowDiscountValue,
    getRowDiscountFlatFee,
    getRowVariableQuantityField,
    hasDiscount,
  }),
})
export default class PricingTableRow extends Vue {
  @Prop() row: IPricingTableRow;
  @Prop() columns: IPricingTableColumn[];
  @Prop() isBlockWidthSmall: boolean;
  @Prop() fields: IField[];
  @Prop() recipientInput: IEditorRecipientInput[];
  @Prop() recipient: IRecipient & { status?: ERecipientStatus };
  @Prop() context: EContext;
  @Prop() currencySettings: IPricingTableCurrencySettings;
  @Prop() gridTemplateColumns: string;
  @Prop() mergeValues: IMergeValues;
  @Prop() isPreCalculated: boolean;

  @Watch('fields', { immediate: true })
  watchFields() {
    if (!this.rowVariableQuantityField?.value) {
      this.rowVariableQuantityField = this.rowVariableQuantityInputField();
    }
  }

  debounceUpdate: (payload: { id: string; value: string }) => void = debounce(
    this.handleDebounceUpdateVariableQuantityField,
    300
  );

  showVariableQuantityMenu = false;
  showAlert = false;
  alertText = '';

  rowVariableQuantityField: Partial<IField> = {
    value: null,
  };

  get showDescription(): boolean {
    return !getRowDescriptionIsEmpty(this.columns, getRowValues(this.row));
  }

  get showSku(): boolean {
    return !getRowSkuValueIsEmpty(this.columns, getRowValues(this.row));
  }

  get showDiscount(): boolean {
    return (
      getRowDiscountEnabled(this.columns) &&
      !getRowDiscountValueIsEmpty(this.columns, getRowValues(this.row))
    );
  }

  get isDocumentView() {
    return this.context === EContext.DocumentView;
  }

  get recipientStatus() {
    return this.recipient?.status;
  }

  get isEditable() {
    return !SigningHelper.hasRecipientSigned(this.recipientStatus) && !this.isDocumentView;
  }

  get hasOptionalProductDeselected() {
    return this.rowOptionalProductInputField()?.value === '0';
  }

  rowOptionalProductInputField() {
    const field = getRowOptionalProductField(this.row, this.fields);
    if (!field) {
      return null;
    }

    field.value = this.getFieldValue(field);
    return field;
  }

  rowVariableQuantityInputField() {
    const field = getRowVariableQuantityField(this.row, this.fields);
    if (!field) {
      return null;
    }

    field.value = this.getFieldValue(field);
    return field;
  }

  getFieldValue(input: IField): string {
    if (!input) {
      return;
    }
    const fieldValue = this.recipientInput?.find(field => field.fieldId === input.id)?.value;

    if (fieldValue) {
      return fieldValue;
    }

    return input.value;
  }

  handleUpdateVariableQuantityField(payload: { id: string; value: string }) {
    this.rowVariableQuantityField.value = payload.value;
    this.debounceUpdate(payload);
  }

  handleDebounceUpdateVariableQuantityField(payload: { id: string; value: string }) {
    this.$emit('update-input-value', payload);
  }

  handleUpdateChecked(payload: { id: string; value: string }) {
    this.$emit('update-input-value', payload);
  }

  handleCloseVariableQuantityMenu() {
    this.showVariableQuantityMenu = false;
  }

  formatPrice(price: string): string {
    const value = price === '' ? '0' : price;
    return PricingTableHelper.currencyFormat(value, this.currencySettings);
  }

  formatNumber(inputValue: string, type: ENumberInputType): string {
    const value = inputValue === '' ? '0' : inputValue;
    switch (type) {
      case ENumberInputType.Number:
        return value;

      case ENumberInputType.Text:
        return value;

      case ENumberInputType.Percentage:
        return `${value}%`;

      case ENumberInputType.Currency:
        return PricingTableHelper.currencyFormat(value, this.currencySettings);

      default:
        return value;
    }
  }
}
